import { cssRule } from 'typestyle';

cssRule('.tb-hidden', {
    visibility: 'hidden',
});

cssRule('.tb-relative', {
    position: 'relative',
});

cssRule('.tb-absolute', {
    position: 'absolute',
});

cssRule('.tb-fill', {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
});

cssRule('.tb-fill-centered', {
    display: 'flex',
    justifyContent: 'space-around',
    '-webkit-justify-content': 'space-around',
    alignItems: 'center',
    width: '100%',
    height: '100%',
});

cssRule('.tb-fill-width', {
    position: 'absolute',
    left: 0,
    right: 0,
});

cssRule('.tb-flex-fill', {
    overflowY: 'auto',
    position: 'relative',
    flex: 1,
    '-webkit-flex': 1,
});

cssRule('.tb-column-flex-parent', {
    display: '-webkit-flex',
    flexDirection: 'column',
    '-webkit-flex-direction': 'column',
});

cssRule('.tb-row-flex-parent', {
    display: '-webkit-flex',
    flexDirection: 'row',
    '-webkit-flex-direction': 'row',
});

cssRule('.tb-bottom', {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
});

cssRule('.tb-top-left', {
    position: 'absolute',
    top: 0,
    left: 0,
});

cssRule('.tb-top-1-left', {
    position: 'absolute',
    top: '1px',
    left: 0,
});

cssRule('.tb-top-left-1', {
    position: 'absolute',
    top: 0,
    left: '1px',
});

cssRule('.tb-top-right', {
    position: 'absolute',
    top: 0,
    right: 0,
});

cssRule('.tb-top-1-right', {
    position: 'absolute',
    top: '1px',
    right: 0,
});

cssRule('.tb-top-right-1', {
    position: 'absolute',
    top: 0,
    right: '1px',
});

cssRule('.tb-bottom-left', {
    position: 'absolute',
    bottom: 0,
    left: 0,
});

cssRule('.tb-bottom-1-left', {
    position: 'absolute',
    bottom: '1px',
    left: 0,
});

cssRule('.tb-bottom-left-1', {
    position: 'absolute',
    bottom: 0,
    left: '1px',
});

cssRule('.tb-bottom-right', {
    position: 'absolute',
    bottom: 0,
    right: 0,
});

cssRule('.tb-bottom-1-right', {
    position: 'absolute',
    bottom: '1px',
    right: 0,
});

cssRule('.tb-bottom-right-1', {
    position: 'absolute',
    bottom: 0,
    right: '1px',
});

